{
  "transferwithexternalwallet": "This transfer will be made with your external wallet balance"
}
